import { createSelector } from 'redux-starter-kit';
const messageSelector = (state: any) => state.messages;

export const messagesSelectors = {
  getMessages: createSelector(messageSelector, subState => subState.messages)
};
